import _ from 'lodash'
const initialState ={
  isExisting:false,
  webform:[],
  isPending:false
}
export default (state = initialState, action) => {
  let new_form = _.cloneDeep(state.webform)
  switch (action.type) {
   case "WEB_FORM_TEMPLATES":
    return Object.assign({}, state, {
      webform: action.payload,
    })
    case "WEB_FORM_TEMPLATES_ADD":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
    })
    case "WEB_FORM_TEMPLATES_MAPPED":
      return Object.assign({}, state, {
        mappedData: action.mappedData,
        isPending: action.isPending,
    })
    case "WEB_FORM_TEMPLATES_NAMES":
        return Object.assign({}, state, {
          formName: action.formName
      })
      case "WEB_FORM_TEMPLATES_NAMES_MAPPED":
        return Object.assign({}, state, {
          formNameMapped: action.formNameMapped
      })
    case "WEB_FORM_TEMPLATES_EDIT":
        var title = action.obj.title
        var index = new_form.findIndex(item => item.title === title)
        new_form.splice(index, 1, action.obj)
      return Object.assign({}, state, {
        webform: new_form
    })
    case "WEB_FORM_TEMPLATES_EXISTING_CHECK":
      return Object.assign({}, state, {
        isExisting: action.isExisting,
        mapCheck: action.mapCheck
     })
    case "WEB_FORM_TEMPLATES_VIEW_REPORT":
      return Object.assign({}, state, {
        report: action.report
      })
    case "WEB_FORM_SEARCH":
      return Object.assign({}, state, {
        searchReport: action.searchReport
      })
    case "WEB_FORM_ERROR":  
    return Object.assign({}, state, {
      showerror: action.showerror,
      errmessage: action.errmessage,
  })
  case "WEB_FORM_MODAL_CLOSE":  
    return Object.assign({}, state, {
      showerror: action.showerror
  })
  case "MAPPING_SUCCESS":
    return Object.assign({}, state, {
      mapCheck: action.isExisting,
      showerror: action.showerror,
      errmessage: action.errmessage,
  })
  case "RESET_MAP_CHECK":
    return Object.assign({}, state, {
      mapCheck: action.isExisting,
    })
    
    case "IS_PENDING":
      return Object.assign({}, state, {
        isPending: action.isPending,
      })  
    default:
     return state
  }
}